import { memo } from 'react';
import {
    Link as RRLink,
    type LinkProps as RRLinkProps,
} from 'react-router-dom';

import cn from 'classnames';

import cls from './link.module.css';

type FontSize = 14 | 16;

interface LinkProps extends RRLinkProps {
    fontSize?: FontSize;
}

export const Link = memo((props: LinkProps) => {
    const { className, fontSize = 14, ...linkProps } = props;

    return (
        <RRLink
            {...linkProps}
            className={cn(className, cls.root, cls[`fontSize${fontSize}`])}
        />
    );
});

Link.displayName = 'Link';
